import ChooseFigureAxisMoveController from "./axismove";
import ChooseFigureButttonPressedController from "./buttonpressed";
import ChooseFigureKeyDownController from "./keydown";
import Gamepad, { Event } from "core/gamepad";
import Deferred from "core/deferred";
export default function ChooseFigureShowController(view) {
  return async () => {
    const model = {
      done: false,
      end: false,
      deferred: new Deferred()
    };
    const keyDownCtrl = ChooseFigureKeyDownController(view, model);
    const buttonPressedCtrl = ChooseFigureButttonPressedController(view, model);
    const axisMoveCtrl = ChooseFigureAxisMoveController(view, model);
    Gamepad.on(Event.ButtonDown, buttonPressedCtrl);
    Gamepad.on(Event.Move, axisMoveCtrl);
    document.addEventListener("keydown", keyDownCtrl);
    view.execute();
    let figureId = null;
    try {
      figureId = await view.askForFigure();
    } catch (err) {}
    Gamepad.off(Event.ButtonDown, buttonPressedCtrl);
    Gamepad.off(Event.Move, axisMoveCtrl);
    document.removeEventListener("keydown", keyDownCtrl);
    return figureId;

    // async function askQuestions() {
    //     let showAssistance = false;

    //     while (survey.hasQuestion()) {
    //         const text = survey.getQuestion();
    //         const answer = survey.getAnswers();
    //         console.log("showing question", text);

    //         const res = await view.askQuestion(text, answer);
    //         showAssistance = showAssistance || (survey.hasAssistance() && survey.needsAssistance(res));
    //         survey.setAnswer(res);
    //         survey.gotoNextQuestion();

    //         console.log("answer", res)
    //     }
    //     console.log("ass", showAssistance);
    //     const answers = survey.getAllAnswers();
    //     return { showAssistance, answers };
    // }
  };
}